import { IFormLabelStyleData } from "@pageBuilder/typings";
import { CssProperties, ICssProperty } from "src/models/css-property";

export class FormLabelStyleRenderer {

    public getStyles(style?: IFormLabelStyleData): ICssProperty[] {
        const formLabelStyle = new CssProperties();

        formLabelStyle.tryAdd("--form-label-font-color", style?.font?.color);
        formLabelStyle.tryAdd("--form-label-font-family", style?.font?.family);
        formLabelStyle.tryAdd("--form-label-font-weight", style?.font?.weight);

        return formLabelStyle.data;
    }

}
